import { Box } from '@mui/material'
import type { ReactNode } from 'react'
import type { SimulationInput } from '../../api/types'
import type { Field, FieldKey } from './formFields'
import NumberField from './NumberField'

export default function FieldsGrid({
  fields,
  form,
  setNum,
  children,
}: {
  fields: Field[]
  form: SimulationInput
  setNum: (key: FieldKey, raw: string) => void
  children?: ReactNode
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
      }}
    >
      {fields.map((field) => (
        <NumberField key={field.key} field={field} form={form} setNum={setNum} />
      ))}
      {children}
    </Box>
  )
}
